<div class="min-h-screen bg-gray-900 py-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
      <div>
        <h1 class="text-3xl font-bold text-white">Projecten</h1>
        <p class="mt-1 text-sm text-gray-400">Beheer je projecten portfolio</p>
      </div>
      <div class="mt-4 sm:mt-0">
        <button
          (click)="navigateToNewProject()"
          class="inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Nieuw Project
        </button>
      </div>
    </div>

    <!-- Search + Filter -->
    <div class="mb-6 flex flex-col sm:flex-row sm:items-center gap-4">
      <div class="relative flex-1 max-w-md">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          [(ngModel)]="filterText"
          (ngModelChange)="onFilterChange()"
          placeholder="Zoek projecten..."
          class="w-full pl-10 pr-4 py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-gray-200 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent">
      </div>
      <button
        (click)="onToggleAllDomains()"
        [class]="showAllDomains
          ? 'inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg bg-indigo-600 text-white border border-indigo-500 transition-colors'
          : 'inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg bg-gray-800 text-gray-400 border border-gray-700 hover:border-gray-600 hover:text-gray-200 transition-colors'">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        {{ showAllDomains ? 'Alle sites' : 'Huidige site' }}
        <span class="px-1.5 py-0.5 text-xs rounded-full" [class]="showAllDomains ? 'bg-indigo-500/30 text-indigo-200' : 'bg-gray-700 text-gray-400'">
          {{ filteredProjects.length }}
        </span>
      </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="flex justify-center items-center py-20">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && filteredProjects.length === 0" class="text-center py-20">
      <svg class="mx-auto h-16 w-16 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
      <h3 class="mt-4 text-lg font-medium text-gray-200">Geen projecten gevonden</h3>
      <p class="mt-2 text-sm text-gray-400">Maak een nieuw project aan om te beginnen.</p>
      <button
        (click)="navigateToNewProject()"
        class="mt-4 inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-medium rounded-lg transition-colors">
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        Nieuw Project
      </button>
    </div>

    <!-- Projects Table -->
    <div *ngIf="!loading && filteredProjects.length > 0" class="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead class="bg-gray-900/50">
            <tr>
              <th class="px-6 py-4 text-left">
                <button (click)="onSort('title')" class="flex items-center text-xs font-semibold text-gray-400 uppercase tracking-wider hover:text-white">
                  Project
                  <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" [attr.d]="getSortIcon('title')" />
                  </svg>
                </button>
              </th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Categorieën</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Talen</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider">Domeinen</th>
              <th class="px-6 py-4 text-right text-xs font-semibold text-gray-400 uppercase tracking-wider">Acties</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-700">
            <tr *ngFor="let project of filteredProjects" 
                class="hover:bg-gray-700/50 transition-colors cursor-pointer"
                (click)="navigateToEditProject(project)">
              <td class="px-6 py-4">
                <div class="flex items-center">
                  <div class="w-12 h-12 rounded-lg bg-gray-700 flex-shrink-0 overflow-hidden mr-4">
                    <img *ngIf="getProjectImage(project)" [src]="getProjectImage(project)" [alt]="getProjectTitle(project)" class="w-full h-full object-cover">
                    <div *ngIf="!getProjectImage(project)" class="w-full h-full flex items-center justify-center">
                      <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                  </div>
                  <div class="min-w-0">
                    <div class="text-sm font-medium text-white truncate max-w-xs">{{ getProjectTitle(project) }}</div>
                    <div class="text-xs text-gray-400 truncate max-w-xs">{{ getProjectDescription(project) }}</div>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4">
                <div class="flex flex-wrap gap-1">
                  <span *ngIf="project.mainCategory" class="px-2 py-0.5 text-xs bg-emerald-600/20 text-emerald-300 rounded font-medium">{{ project.mainCategory }}</span>
                  <span *ngFor="let cat of project.categories" class="px-2 py-0.5 text-xs bg-indigo-600/20 text-indigo-300 rounded">{{ cat }}</span>
                </div>
                <span *ngIf="!project.mainCategory && (!project.categories || project.categories.length === 0)" class="text-sm text-gray-500">-</span>
              </td>
              <td class="px-6 py-4">
                <span *ngIf="getFilledLanguages(project).length > 0" class="text-sm text-gray-300">
                  {{ getFilledLanguages(project).join(' · ') }}
                </span>
                <span *ngIf="getFilledLanguages(project).length === 0" class="text-sm text-gray-500">-</span>
              </td>
              <td class="px-6 py-4" (click)="$event.stopPropagation()">
                <div *ngIf="!editingDomains[project.id!]">
                  <button
                    (click)="toggleDomainEditor(project)"
                    class="text-sm text-indigo-400 hover:text-indigo-300 transition-colors">
                    {{ getDomainDisplay(project) }}
                  </button>
                </div>
                <div *ngIf="editingDomains[project.id!]" class="space-y-2">
                  <div *ngFor="let domain of availableDomains" class="flex items-center">
                    <input
                      type="checkbox"
                      [checked]="isDomainSelected(project, domain)"
                      (change)="toggleDomainSelection(project, domain)"
                      class="w-4 h-4 rounded bg-gray-700 border-gray-600 text-indigo-600 focus:ring-indigo-500">
                    <span class="ml-2 text-sm text-gray-300">{{ domain }}</span>
                  </div>
                  <div class="flex gap-2 mt-2">
                    <button
                      (click)="saveDomains(project)"
                      class="px-2 py-1 text-xs bg-indigo-600 text-white rounded hover:bg-indigo-500">
                      Opslaan
                    </button>
                    <button
                      (click)="toggleDomainEditor(project)"
                      class="px-2 py-1 text-xs bg-gray-600 text-white rounded hover:bg-gray-500">
                      Annuleren
                    </button>
                  </div>
                </div>
              </td>
              <td class="px-6 py-4" (click)="$event.stopPropagation()">
                <div class="flex items-center justify-end gap-2">
                  <button
                    (click)="navigateToEditProject(project)"
                    class="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
                    title="Bewerken">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>
                  <button
                    (click)="openDeleteModal(project)"
                    class="p-2 text-gray-400 hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors"
                    title="Verwijderen">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<app-confirm-modal
  [show]="showDeleteModal"
  title="Project Verwijderen"
  [message]="'Weet je zeker dat je \'' + (projectToDelete ? getProjectTitle(projectToDelete) : '') + '\' wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.'"
  (onConfirm)="deleteProject()"
  (onCancel)="closeDeleteModal()">
</app-confirm-modal>

<app-notification></app-notification>
